import React from 'react';
// CodeMirror 6 React wrapper
// Note: Ensure dependency is installed in frontend: `npm i @uiw/react-codemirror @codemirror/language @codemirror/theme-one-dark @codemirror/view @codemirror/state @codemirror/basic-setup`.
// We keep imports minimal to reduce bundle.
import CodeMirror from '@uiw/react-codemirror';
import { json } from '@codemirror/lang-json';
import { oneDark } from '@codemirror/theme-one-dark';
import { useTheme } from '../ThemeContext';

export type CodeViewerProps = {
  value: string;
  language?: 'json' | 'text' | 'python';
  theme?: 'light' | 'dark';
  height?: string | number;
  style?: React.CSSProperties;
  className?: string;
};

export default function CodeViewer({ value, language = 'json', theme: themeProp, height = '360px', style, className }: CodeViewerProps) {
  const { isDarkMode } = useTheme();
  const extensions = React.useMemo(() => {
    const exts: any[] = [];
    if (language === 'json') exts.push(json());
    return exts;
  }, [language]);

  // Use themeProp if provided, otherwise use context
  const effectiveTheme = themeProp || (isDarkMode ? 'dark' : 'light');

  // Container styles to mimic previous <pre> area styling
  const containerStyle: React.CSSProperties = {
    border: effectiveTheme === 'dark' ? '1px solid #1e3a47' : '1px solid #e5e7eb',
    borderRadius: 6,
    overflow: 'hidden',
    ...style,
  };

  return (
    <div className={className} style={containerStyle}>
      <CodeMirror
        value={value}
        height={typeof height === 'number' ? `${height}px` : height}
        readOnly
        editable={false as any}
        theme={effectiveTheme === 'dark' ? oneDark : undefined}
        basicSetup={{
          lineNumbers: true,
          highlightActiveLine: false,
          highlightActiveLineGutter: false,
        } as any}
        extensions={extensions}
      />
    </div>
  );
}
